export default __webpack_public_path__ + "static/media/menu.98c11634.png";